export default "__VITE_ASSET__BoU2IZg8__"